import { render, staticRenderFns } from "./copyProjectPersonal.vue?vue&type=template&id=32e977ca&scoped=true&"
import script from "./copyProjectPersonal.vue?vue&type=script&lang=js&"
export * from "./copyProjectPersonal.vue?vue&type=script&lang=js&"
import style0 from "./copyProjectPersonal.vue?vue&type=style&index=0&id=32e977ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e977ca",
  null
  
)

export default component.exports